import Result from 'ant-design-pro/lib/Result';
import { Button, DatePicker, Form, InputNumber, message, Row, Steps } from 'antd';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import TextArea from 'antd/lib/input/TextArea';
import gql from 'graphql-tag';
import * as moment from 'moment';
import React, { Component } from 'react';
import { Panel } from 'src/components/Panel';
import { MarketingActivityRuleKey, MarketingActivityRuleType } from 'src/types/marketingActivity';

import { client } from '../../services/api';
import { LimitSku, UserLimitConfigForm } from './UserLimitConfig';

const { Step } = Steps;

export const formItemLayout = {
  labelCol: {
    xs: { span: 10 },
    sm: { span: 12 },
  },
  wrapperCol: {
    xs: { span: 10 },
    sm: { span: 12 },
  },
};
export interface Rule {
  ruleKey: MarketingActivityRuleKey;
  ruleName: string;
  ruleType: MarketingActivityRuleType;
  ruleValue: RuleValue | LimitConfigValue | LimitCongValue;
  activityId: number;
  remark: string;
}

export interface LimitConfigValue {
  dueAt: Date;
  price: number;
}

export interface RuleValue {
  desposit: number;
  depositStartAt?: Date;
  depositEndAt?: Date;
  finalPaymentStartAt?: Date;
  finalPaymentEndAt?: Date;
  discount: number;
}

export interface LimitCongValue {
  skuId?: number;
  ownedSkuId?: number;
}

export const createMarketingActivityRulesMutation = gql`
  mutation createMarketingActivityRule($activityId: Int, $rules: [JSON]) {
    createMarketingActivityRule(activityId: $activityId, rules: $rules) {
      id
    }
  }
`;

interface Props {
  form: WrappedFormUtils;
  activityId: number;
  despositConfigRule?: RuleValue;
}
interface State {
  desposit: number;
  discount: number;
  depositEndAt?: Date;
  depositStartAt?: Date;
  finalPaymentEndAt?: Date;
  finalPaymentStartAt?: Date;
  remark: string;
  current: number;
  limitSkuList: LimitSku[];
}

export class AdvancedDesposit extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      current: 0,
      desposit: 0,
      discount: 0,
      remark: '',
      limitSkuList: [
        {
          id: '0',
          isLimitSku: 'named',
          skuId: '',
          isLimitOwnedSku: 'named',
          ownedSkuId: '',
        },
      ],
    };
  }

  userLimitRuleList = () => {
    const { activityId } = this.props;
    const { limitSkuList } = this.state;
    const userLimitConfigValues: Rule[] = [];
    limitSkuList.forEach(item => {
      const limitConfig: LimitCongValue = {};
      if (item.isLimitOwnedSku === 'named') {
        limitConfig.ownedSkuId = Number(item.ownedSkuId);
        userLimitConfigValues.push({
          activityId,
          remark: '用户限制配置',
          ruleKey: MarketingActivityRuleKey.MA_RULE_USERS_LIMIT_CONFIG,
          ruleName: '预付定金活动用户sku限制',
          ruleType: MarketingActivityRuleType.CONSTRAINT,
          ruleValue: { ownedSkuId: Number(item.ownedSkuId) },
        });
      }

      if (item.isLimitSku === 'named') {
        limitConfig.skuId = Number(item.skuId);
      }
      userLimitConfigValues.push({
        activityId,
        remark: '拥有与购买SKU映射',
        ruleKey: MarketingActivityRuleKey.USER_SKU_MAPPING,
        ruleName: '拥有与购买SKU映射',
        ruleType: MarketingActivityRuleType.DETAIL,
        ruleValue: limitConfig,
      });
    });

    return userLimitConfigValues;
  };

  activityContentConfig = async () => {
    const { activityId } = this.props;
    this.props.form.validateFieldsAndScroll(async (err, values) => {
      if (err) {
        message.error(err);
        return;
      }
      const { remark, discount, desposit } = values;
      const { depositEndAt, depositStartAt, finalPaymentEndAt, finalPaymentStartAt } = this.state;
      const ruleValue: RuleValue = {
        discount,
        desposit,
        depositStartAt,
        depositEndAt,
        finalPaymentEndAt,
        finalPaymentStartAt,
      };

      const rule: Rule = {
        ruleValue,
        activityId,
        remark,
        ruleKey: MarketingActivityRuleKey.MA_RULE_PREORDER_CONFIG,
        ruleName: '预付定金活动配置',
        ruleType: MarketingActivityRuleType.DETAIL,
      };
      const configList: Rule[] = [...this.userLimitRuleList(), rule];
      await client
        .mutate({
          mutation: createMarketingActivityRulesMutation,
          variables: { activityId: Number(activityId), rules: configList },
        })
        .then(res => {
          if (res.data) {
            message.success('设置成功！');
            const current = this.state.current + 1;
            this.setState({ current });
          }
        })
        .catch(error => {
          const [err] = error.graphQLErrors;
          message.error(err.message);
        });
    });
  };

  onDespositStartAtChange = (date: moment.Moment) => {
    this.setState({
      depositStartAt: moment(date).startOf('day').utc().toDate(),
    });
  };

  onDespositEndAtChange = (date: moment.Moment) => {
    this.setState({
      depositEndAt: moment(date).endOf('day').utc().toDate(),
    });
  };

  onFinalPayStartAtChange = (date: moment.Moment) => {
    this.setState({
      finalPaymentStartAt: moment(date).startOf('day').utc().toDate(),
    });
  };

  onFinalPayEndAtChange = (date: moment.Moment) => {
    this.setState({
      finalPaymentEndAt: moment(date).endOf('day').utc().toDate(),
    });
  };

  prev = () => {
    const current = this.state.current - 1;
    this.setState({ current });
  };

  next = (list: LimitSku[]) => {
    const current = this.state.current + 1;
    this.setState({ current, limitSkuList: list });
  };

  onDespositChange = (e: number) => {
    this.setState({ desposit: e });
  };

  onDiscountChange = (e: number) => {
    this.setState({ discount: e });
  };

  onRemarkChange = (e: { target: { value: string } }) => {
    this.setState({ remark: e.target.value });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { activityId } = this.props;
    const {
      current,
      desposit,
      discount,
      remark,
      depositEndAt,
      finalPaymentEndAt,
      finalPaymentStartAt,
      depositStartAt,
      limitSkuList,
    } = this.state;

    const steps = [
      {
        title: '用户限制配置',
        content: (
          <UserLimitConfigForm
            limitSkuList={limitSkuList}
            activityId={Number(activityId)}
            next={list => this.next(list)}
          />
        ),
      },
      {
        title: '活动配置',
        content: (
          <Form style={{ marginTop: 30 }}>
            <Form.Item label="定金" {...formItemLayout}>
              {getFieldDecorator('desposit', {
                initialValue: desposit || '',
                rules: [
                  {
                    required: true,
                    message: '请填写定金',
                  },
                ],
              })(<InputNumber placeholder="定金" onChange={this.onDespositChange} />)}
            </Form.Item>
            <Form.Item label="抵扣" {...formItemLayout}>
              {getFieldDecorator('discount', {
                initialValue: discount || '',
                rules: [
                  {
                    required: true,
                    message: '请填写抵扣金额',
                  },
                ],
              })(<InputNumber placeholder="抵扣" onChange={this.onDiscountChange} />)}
            </Form.Item>
            <Form.Item {...formItemLayout} label="定金支付开始时间">
              {getFieldDecorator('depositStartAt', {
                initialValue: moment(depositStartAt),
                rules: [
                  {
                    required: true,
                    message: '请选择开始时间',
                  },
                ],
              })(<DatePicker onChange={this.onDespositStartAtChange} />)}
            </Form.Item>
            <Form.Item {...formItemLayout} label="定金支付结束时间">
              {getFieldDecorator('depositEndAt', {
                initialValue: moment(depositEndAt),
                rules: [
                  {
                    required: true,
                    message: '请选择结束时间',
                  },
                ],
              })(<DatePicker onChange={this.onDespositEndAtChange} />)}
            </Form.Item>
            <Form.Item {...formItemLayout} label="尾款支付开始时间">
              {getFieldDecorator('finalPaymentStartAt', {
                initialValue: moment(finalPaymentStartAt),
                rules: [
                  {
                    required: true,
                    message: '请选择开始时间',
                  },
                ],
              })(<DatePicker onChange={this.onFinalPayStartAtChange} />)}
            </Form.Item>
            <Form.Item {...formItemLayout} label="尾款支付结束时间">
              {getFieldDecorator('finalPaymentEndAt', {
                initialValue: moment(finalPaymentEndAt),
                rules: [
                  {
                    required: true,
                    message: '请选择结束时间',
                  },
                ],
              })(<DatePicker onChange={this.onFinalPayEndAtChange} />)}
            </Form.Item>
            <Form.Item label="备注" {...formItemLayout}>
              {getFieldDecorator('remark', {
                initialValue: remark,
                rules: [
                  {
                    required: true,
                    message: '请填写备注',
                  },
                ],
              })(
                <TextArea
                  placeholder="请填写备注"
                  rows={3}
                  autosize={false}
                  style={{ width: 300 }}
                  onChange={this.onRemarkChange}
                />,
              )}
            </Form.Item>
            <Row type="flex" justify="end">
              <Button type="primary" style={{ marginRight: 5 }} onClick={this.prev}>
                上一步
              </Button>
              <Button type="primary" onClick={this.activityContentConfig}>
                完成配置
              </Button>
            </Row>
          </Form>
        ),
      },
      {
        title: '配置完成',
        content: <Result style={{ marginTop: 30 }} title="配置成功！" type="success" />,
      },
    ];
    return (
      <>
        <Panel style={{ padding: 20 }}>
          <Steps current={current}>
            {steps.map(item => (
              <Step key={item.title} title={item.title} />
            ))}
          </Steps>
          <div className="steps-content">{steps[current].content}</div>
        </Panel>
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/marketing/AdvancedDesposit.tsx